import axios from "axios";

const API_BASE = process.env.REACT_APP_BACKEND_URL;
const BASE = `${API_BASE}/api`;
const api = axios.create({ baseURL: BASE, withCredentials: false });


// Pre-token aware instance for 2FA flows when we only have pre_token
export const apiPre = axios.create({ baseURL: BASE, withCredentials: false });
apiPre.interceptors.request.use((config)=>{
  const pre = localStorage.getItem("pre_token");
  if(pre) config.headers.Authorization = `Bearer ${pre}`;
  return config;
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (error) => {
    const status = error?.response?.status;
    const path = (typeof window !== 'undefined' && window.location && window.location.pathname) ? window.location.pathname : '';
    
    // On 401 Unauthorized - session expired or invalid token
    if (status === 401) {
      // Don't redirect if already on login page or widget pages
      if (!path.startsWith('/login') && !path.startsWith('/widget/')) {
        window.dispatchEvent(new CustomEvent('auth-required'));
      }
    }
    
    // Forbidden requests must not discard unsaved forms or impersonation state.
    
    return Promise.reject(error);
  }
);

export default api;
